import { Ability, AbilityBuilder } from '@casl/ability'

Ability.addAlias('manage', ['update', 'delete', 'create', 'view', 'translate', 'validate', 'read']);

function subjectName (subject) {
  if (!subject || typeof subject === 'string') {
    return subject;
  }

  const Type = typeof subject === 'object' ? subject.constructor : subject;

  return Type.modelName || Type.name;
}

export default AbilityBuilder.define({ subjectName }, can => { });


// WEBPACK FOOTER //
// ./src/abilities.js